export const environment = {
  production: true,
  environmentName: "Production",
  API_URL: "https://api.24trains.tv/preprod",
  SOCIAL_LOGIN: "https://api.24trains.tv/preprod",
  version: "v2/",
  v3_version: "v3/",
  ANGULAR_SITE_URL: "https://24trains.tv2zdev.com/",
  IMAGE_PATH_URL: "",
  IMAGE_PATH_URL_CONVERTED: "",
  TRANSLATE_PATH_URL: "",
  BASE_URL: "https://24trainsssr.tv2zdev.com",
  COKKIE_DOMAIN: "api.24trains.tv",
  APP_NAME: "24trains",
  htmlAppName: "tv2z",
  indexFile: "index.html",
};
